"use client";
import { Fragment, useLayoutEffect } from "react";
import dynamic from "next/dynamic";
import { Box, Divider, Stack } from "@mui/material";

import { observer, useStore } from "../../../../service/mobx";

const Api = dynamic(() => import("./Api"));
const Feed = dynamic(() => import("./Feed"));
const Agent = dynamic(() => import("../../../agent/Client"));

function LoggedOut({ count, models, trending, tasksWithCounts }) {
  const { layout, device } = useStore();

  const sections = [
    {
      Component: () => (
        <Box sx={{ minHeight: "100dvh" }}>
          <Api
            count={count}
            models={models}
            trending={trending}
            tasksWithCounts={tasksWithCounts}
          />
        </Box>
      ),
      appendDivider: device.isPhone
    },
    {
      Component: () => (
        <Box sx={{ minHeight: "100dvh", overflowX: "hidden" }}>
          <Feed
            count={count}
            models={models}
            trending={trending}
            tasksWithCounts={tasksWithCounts}
          />
        </Box>
      ),
      appendDivider: device.isPhone
    },
    {
      Component: () => (
        <Box
          sx={{
            // this is to prevent the chopping of the bottom of the page on devices with
            mb: device.isPhone ? 12 : 2,
            // this is to undo the 9 pt statically coded in the component
            mt: -9,
            minHeight: "100dvh"
          }}
        >
          <Agent
            count={count}
            models={models}
            trending={trending}
            tasksWithCounts={tasksWithCounts}
          />
        </Box>
      )
    }
  ];

  useLayoutEffect(() => {
    const element = document.getElementById("layout");

    layout.set.navOpen(false);
    layout.set.maxWidth(false);

    document.body.style.overflow = "hidden";
    element.style.overflowY = "scroll";
    element.style.height = "100dvh";
    // element.style.scrollSnapType = "y mandatory";

    // we have 3 100vw pages here, and safari starts at bottom, chrome starts at top
    // this effect always start the page at the top
    setTimeout(() => {
      element.scrollTop = 0;
    }, 0);

    return () => {
      const element = document.getElementById("layout");

      layout.set.maxWidth();
      document.body.style.removeProperty("overflow");

      if (element) {
        element.style.removeProperty("height");
        element.style.removeProperty("overflowY");
        element.style.removeProperty("scrollSnapType");
      }
    };
  }, [layout]);

  return (
    <Stack spacing={device.isPhone ? 4 : 10}>
      {sections.map(({ Component, appendDivider }, index) => (
        <Fragment key={index}>
          <Component />
          {appendDivider ? <Divider sx={{ mx: 2, opacity: 0.25 }} /> : null}
        </Fragment>
      ))}
    </Stack>
  );
}

export default observer(LoggedOut);
